/** Router state a screen is opened with from the Work list: where its Back returns, filters included. */
export interface FromWork {
  backTo?: string;
}

/** The client's Work list, unfiltered: where Back goes when the screen was not opened from Work (a link, a refresh). */
export function workListUrl(clientId: string): string {
  return clientId ? `/clients?${new URLSearchParams({ clientId, tab: 'work' }).toString()}` : '/clients';
}

/**
 * Where Back returns: the Work list the screen was opened from, else the client's own. The remembered one counts only
 * when it is this app's Clients screen for THIS client: a client picked in the header since then goes to its own list.
 */
export function backTarget(state: unknown, clientId: string): string {
  const backTo = (state as FromWork | null)?.backTo;
  if (typeof backTo !== 'string' || !backTo.startsWith('/clients')) return workListUrl(clientId);
  const query = backTo.includes('?') ? backTo.slice(backTo.indexOf('?') + 1) : '';
  return new URLSearchParams(query).get('clientId') === clientId ? backTo : workListUrl(clientId);
}
